exports.log = function (msg) {
  console.log(msg);
}



/*****************
 ** WEBPACK FOOTER
 ** ./js/log.js
 ** module id = 2
 ** module chunks = 0
 **/